import { Box, HStack, Text } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { CloseIcon } from 'assets/icons/v2';
import React, { ReactElement } from 'react';
import { Z_INDEX } from 'styles/zIndex';

type Props = {
  title?: string;
  onBackClick?: () => void;
  ButtonComponents?: ReactElement;
};

export const TopBarWorksheetSession = ({
  title,
  onBackClick,
  ButtonComponents,
}: Props): ReactElement => {
  const handleBackClick = (): void => {
    onBackClick?.();
  };

  // const handleSubmit = (): void => {
  //   submitButtonOptions?.onSubmit();
  // };

  return (
    <Box
      top="0"
      position="sticky"
      zIndex={Z_INDEX.SEARCH_BAR}
      padding="20px 0px 15px"
      bg="background.primary"
      px={{ base: 'l', md: '25px' }}
      boxShadow="0px 0px 15px 0px rgba(0, 0, 0, 0.06)"
    >
      <Box
        maxW="1920px"
        width="100%"
        margin="0 auto"
        display="flex"
        alignItems="center"
        gap="10px"
        justifyContent="space-between"
        height="60px"
      >
        <HStack gap="l">
          <NovaIconButton
            aria-label="Zurück"
            variant="primary"
            size="l"
            onClick={handleBackClick}
            lineHeight="normal"
            icon={CloseIcon}
          />
          <Text
            textStyle="h3.medium"
            color="text.primary"
            display={{
              base: 'none',
              md: 'block',
            }}
          >
            {title}
          </Text>
        </HStack>
        <Text
          textStyle="h3.medium"
          color="text.primary"
          display={{
            base: 'block',
            md: 'none',
          }}
          lineClamp={1}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {title}
        </Text>
        <HStack>{ButtonComponents}</HStack>
      </Box>
    </Box>
  );
};
